/**
 * Error thrown when Cognito requires a new password from user
 */
export class CognitoNewPasswordRequiredError extends Error {
  constructor(message: string) {
    super(message);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, CognitoNewPasswordRequiredError.prototype);
  }
}
